import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import GetAppIcon from '@material-ui/icons/GetApp';

import usePdfComprobante from '../hooks/usePdfComprobante';
import VisorPdf from '../VisorPdf/VisorPdf';
import { nombreComprobante } from '../textosComprobante';

const useStyles = makeStyles((theme) => ({
  content: {
    height: '75vh',
    // A pantalla completa (celular) el visor ocupa lo que dejan el título y los botones
    [theme.breakpoints.down('xs')]: {
      height: 'auto',
      flex: 1
    },
    padding: '0px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
}));

/**
 * Vista previa del PDF de un comprobante, con botón para descargarlo con el nombre que arma el Eiffel.
 * El PDF se pide al abrir (queda registrado como descargado) y el blob URL se libera al cerrar.
 */
const ImpresionPdfModal = ({ comprobante, onClose }) => {
  const classes = useStyles();
  const { pdf, error } = usePdfComprobante(comprobante);
  // En celular el modal ocupa toda la pantalla.
  const pantallaCompleta = useMediaQuery((theme) => theme.breakpoints.down('xs'));

  return (
    <Dialog open={!!comprobante} onClose={onClose} fullWidth fullScreen={pantallaCompleta} maxWidth="lg">
      <DialogTitle>{comprobante ? nombreComprobante(comprobante) : ''}</DialogTitle>
      <DialogContent dividers className={classes.content}>
        <VisorPdf pdf={pdf} error={error} />
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          variant="contained"
          startIcon={<GetAppIcon />}
          disabled={!pdf}
          href={pdf ? pdf.url : undefined}
          download={pdf ? pdf.nombreArchivo : undefined}
        >
          Descargar
        </Button>
        <Button onClick={onClose}>Cerrar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ImpresionPdfModal;
